import type { Components, Theme } from '@mui/material';

export const MuiRadio: Components<Theme>['MuiRadio'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&.Mui-checked': {
        color: theme.palette.neutral.darker,
      },
    }),
  },
};
